import { render } from "./LandingFooter.vue?vue&type=template&id=5d1bce80&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"

import "./LandingFooter.vue?vue&type=style&index=0&id=5d1bce80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1bce80"]])

export default __exports__